// Central content source for Vernika Designs LLP

export const BRAND = {
  name: "VERNIKA DESIGNS",
  legal: "VERNIKA DESIGNS LLP",
  unit: "A Unit of VERNIKA DESIGNS LLP",
  tagline: "Interiors Beyond Limitations",
  hero: "Complete Interior Solutions Under One Roof",
  logo: "https://customer-assets-39nsmqrw.emergentagent.net/job_luxury-interiors-135/artifacts/69nwio33_d44ed349-13ad-4238-a835-115f0d1f9892.jpeg",
  phones: ["+91 8902706347", "+91 9627758578"],
  phoneRaw: ["918902706347", "919627758578"],
  email: "varnikadesigns24@gmail.com",
  whatsapp: "918902706347",
  address: {
    lines: [
      "Bhatenda, Rajarhat Bishnupur No. 1 Gram Panchayat",
      "P.O. & P.S. – Rajarhat",
      "District – North 24 Parganas",
      "Kolkata – 700135, West Bengal, India",
    ],
    landmark: "Beside HDFC Bank, on 91 Bus Route",
  },
  social: {
    instagram: "https://instagram.com",
    facebook: "https://facebook.com",
    whatsapp: "https://wa.me/918902706347",
  },
};

export const HERO_IMAGE = "/photos/brand/hero.jpeg";

export const PRODUCT_GROUPS = [
  {
    key: "plywood",
    title: "Plywood & Boards",
    blurb: "Engineered strength for every structure — from marine-grade cores to precision-milled boards.",
    image: "https://images.unsplash.com/photo-1611072337226-1140ab367200",
    items: ["Commercial Plywood", "BWP Plywood", "Marine Plywood", "Block Board", "MDF Board", "PVC Board", "Flush Doors"],
  },
  {
    key: "laminates",
    title: "Laminates & Decorative Surfaces",
    blurb: "Finishes that define a space — textures, veneers and panels curated for the discerning eye.",
    image: "https://images.unsplash.com/photo-1722348675220-ad796b88b724",
    items: ["Decorative Laminates", "High Pressure Laminates (HPL)", "Acrylic Sheets", "Veneers", "Charcoal Panels", "Wall Panels"],
  },
  {
    key: "hardware",
    title: "Interior Hardware",
    blurb: "The details that endure — intelligent locks, sculpted handles and precision fittings.",
    image: "https://images.unsplash.com/photo-1755288556425-f60755b10bff",
    items: [
      "Digital Door Locks", "Smart Locks", "Main Door Handles", "Designer Handles",
      "Cabinet Handles", "Wardrobe Handles", "Hinges", "Drawer Channels",
      "Sliding Systems", "Door Closers", "Modular Kitchen Accessories",
      "Bathroom Accessories", "Adhesives", "Screws & Fasteners",
    ],
  },
];

export const MISSION =
  "To transform everyday spaces into extraordinary expressions of life and style — delivering thoughtfully designed interiors and premium products with creativity, craftsmanship and seamless execution, tailored to each client's lifestyle.";

export const VISION =
  "To be a trusted name in interior solutions — redefining living experiences by blending innovative design with timeless aesthetics, and making great interiors accessible, personal and transformative for every home and workspace we touch.";

export const WHY_CHOOSE = [
  { title: "Complete Interior Solutions", icon: "LayoutGrid" },
  { title: "Premium Quality Products", icon: "Gem" },
  { title: "Trusted Brands", icon: "BadgeCheck" },
  { title: "Wholesale & Retail Supply", icon: "Store" },
  { title: "Competitive Pricing", icon: "Tag" },
  { title: "Professional Product Guidance", icon: "Compass" },
  { title: "Fast Delivery", icon: "Truck" },
  { title: "Reliable Customer Support", icon: "Headphones" },
  { title: "Long-Term Relationships", icon: "Handshake" },
];

export const CUSTOMERS = [
  "Homeowners", "Architects", "Interior Designers", "Builders",
  "Contractors", "Corporate Offices", "Commercial Projects", "Retail Customers",
];

export const USPS = [
  { title: "Bespoke Interior Solutions", text: "Tailored to how you live — never templated. Every layout, material and finish chosen for your space.", icon: "Sparkles" },
  { title: "End-to-End Execution", text: "From concept and material selection to installation and final handover — one accountable partner, one seamless timeline.", icon: "Workflow" },
  { title: "Collaborative Process", text: "We design with you, not for you. Transparent, honest conversations at every stage of the project.", icon: "Users" },
];

export const SPACES = [
  { name: "Living Room", image: "/photos/living/1.webp" },
  { name: "Pooja Unit", image: "/photos/pooja/1.webp" },
  { name: "Dining", image: "/photos/dining/2.webp" },
  { name: "Modular Kitchen", image: "/photos/kitchen/1.webp" },
  { name: "Bedroom", image: "/photos/bedroom/1.webp" },
  { name: "Bathroom", image: "/photos/bathroom/1.webp" },
];

export const OBJECTS = [
  {
    title: "Interior Decoration & Turnkey Projects",
    text: "Interior decoration, designing, space planning, furnishing, renovation, remodeling and turnkey execution for residential, commercial, industrial, institutional and hospitality projects — with full architectural support and project management.",
  },
  {
    title: "Materials, Furniture & Furnishings",
    text: "Manufacture, supply, wholesale and retail of interior decoration materials, modular furniture, fixtures, lighting, flooring, wall coverings, curtains, blinds, carpets, upholstery, sanitary ware, hardware, glass products, décor, modular kitchens and wardrobes.",
  },
  {
    title: "Contracting, Consulting & Distribution",
    text: "Acting as contractors, consultants, designers, suppliers, traders, dealers, distributors, franchisees and service providers across interior decoration and allied products.",
  },
  {
    title: "Allied Interior Services",
    text: "Undertaking every activity that is incidental or conducive to great interior work — with full compliance under the Limited Liability Partnership Act, 2008 and applicable laws.",
  },
];

export const VALUES = [
  {
    title: "Personalized Design",
    text: "No two homes are alike — and no two designs should be either. Every project is built around your lifestyle, your taste and the way you actually live.",
    icon: "HeartHandshake",
  },
  {
    title: "Quality Craftsmanship",
    text: "Premium materials, skilled hands and an obsessive eye for detail. What we build is meant to last, look better with time, and be lived in — beautifully.",
    icon: "Hammer",
  },
];

export const TEAM = [
  {
    name: "Harpreet Singh",
    role: "Co-Founder · Business Partner",
    initials: "HS",
    accent: "#e7c15a",
    bio: [
      "Harpreet Singh is a Co-Founder and Business Partner of Vernika Designs LLP, where he plays a key role in shaping the company's vision, client experience and business growth.",
      "With a strong focus on client consultation, project coordination, vendor partnerships and product selection, he works closely with clients to understand their ideas and transform them into thoughtfully planned interior solutions.",
      "His approach combines creativity, functionality, quality and value — with a strong emphasis on transparent communication and long-term relationships.",
      "His vision is to establish Vernika Designs as a trusted and distinctive name in the interior industry, delivering personalized spaces that truly reflect the people who live and work in them.",
    ],
    quote: "We don't just design spaces; we bring your vision to life — Interiors Beyond Limitations.",
  },
  {
    name: "Saibal Kanti Chaudhury",
    role: "Co-Founder · Business Partner",
    initials: "SC",
    accent: "#e7c15a",
    bio: [
      "Saibal Kanti Chaudhury is a Co-Founder and Business Partner of Vernika Designs LLP, bringing nearly three decades of leadership across business development, channel strategy and organizational growth.",
      "He shares equal responsibility for the company's vision, strategy and long-term direction — with deep experience in building distribution networks, leading high-performing teams and forging lasting partnerships across Eastern India.",
      "At Vernika, he combines sharp market intelligence with on-ground execution to help build a company grounded in trust, transparency and enduring relationships.",
    ],
    quote: "Great business is built on relationships — and every relationship starts with trust.",
  },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "One Roof, Every Solution",
    text: "Plywood, laminates, hardware, locks and accessories — sourced, curated and delivered from a single trusted destination.",
  },
  {
    no: "02",
    title: "Uncompromising Quality",
    text: "We partner only with trusted brands and premium-grade materials engineered to endure a lifetime of living.",
  },
  {
    no: "03",
    title: "Guidance That Elevates",
    text: "From homeowners to architects, our team offers professional guidance that turns ambition into refined spaces.",
  },
  {
    no: "04",
    title: "Relationships Built to Last",
    text: "Competitive pricing, fast delivery and dependable support — the foundation of long-term partnership.",
  },
];

const _mk = (dir, cat, ids, prefix) =>
  ids.map((id) => ({ src: `/photos/${dir}/${id}.webp`, label: `${prefix} · ${String(id).padStart(2, "0")}`, cat }));

export const GALLERY = [
  ..._mk("living", "Living Room", [1, 2, 3, 4, 5, 7, 10], "Living Room"),
  ..._mk("pooja", "Pooja Unit", [1, 11, 2, 3, 4, 5, 6], "Pooja Unit"),
  ..._mk("dining", "Dining", [2, 3, 5, 7, 8, 9, 10], "Dining"),
  ..._mk("kitchen", "Modular Kitchen", [1, 2, 3, 4, 6, 7, 8, 9, 11, 16, 17, 18, 21, 22], "Modular Kitchen"),
  ..._mk("bedroom", "Bedroom", [1, 2, 3, 4, 7, 8, 9, 11, 14, 16, 17, 18, 19, 20, 21, 22, 23, 24, 28, 29, 30, 31, 33, 34, 36, 39, 40, 41], "Bedroom"),
  ..._mk("bathroom", "Bathroom", [1, 10, 11, 12, 13, 14, 15, 17, 18, 20, 21], "Bathroom"),
];

export const PRODUCT_OPTIONS = [
  "Plywood & Boards",
  "Laminates & Decorative Surfaces",
  "Digital Door Locks & Smart Locks",
  "Handles & Architectural Hardware",
  "Modular Kitchen Accessories",
  "Wardrobe Fittings",
  "Bathroom Accessories",
  "Adhesives & Fasteners",
  "Complete Interior Solution",
  "Other",
];
